<div class="modal-header">
  <h2 class="modal-title">
    <span *ngIf="!isBulkMode">{{ memberName }}</span>
    <span *ngIf="isBulkMode">{{ getBulkTitleKey() | translate }}</span>
  </h2>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'general.close' | translate }}"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <div *ngIf="isBulkMode" class="alert alert-warning mb-3">
    <p class="mb-2">
      {{ getBulkMessageKey() | translate }}
      <ng-container *ngIf="bulkMode !== 'all'"
        ><strong>{{ getSelectedMemberNames() }}</strong></ng-container
      >
    </p>
  </div>

  <div *ngIf="isBulkMode" class="form-check mb-3">
    <input
      id="overwrite-existing-answers"
      type="checkbox"
      class="form-check-input"
      [checked]="overwriteExisting"
      (change)="onToggleOverwrite($event)"
    />
    <label class="form-check-label" for="overwrite-existing-answers">
      {{ 'surveyModule.overwriteAnswers' | translate }}
    </label>
  </div>

  <div
    class="border-bottom py-2 d-flex flex-row-reverse align-items-end justify-content-between"
    *ngFor="let row of rows"
  >
    <button
      type="button"
      class="btn btn-ghost-primary"
      [ngClass]="{ active: row.isEditing }"
      (click)="enableEdit(row)"
    >
      <i
        class="fa fa-pencil-alt"
        role="img"
        attr.aria-label="{{ 'general.edit' | translate }}"
      ></i>
    </button>
    <fieldset>
      <legend class="form-label">{{ row.questionLabel }}</legend>

      <div
        class="btn-group rating-group"
        [ngClass]="{ 'is-editing': row.isEditing }"
        [attr.aria-label]="
          !row.isEditing
            ? getDisplayRating(row) + ' ' + ('wcag.ratingStars' | translate)
            : null
        "
        [attr.role]="!row.isEditing ? 'img' : null"
      >
        <button
          *ngFor="let star of stars; let i = index"
          type="button"
          class="btn btn-sm px-1 btn-star"
          [ngClass]="{
            'is-editable btn-white': row.isEditing,
            'is-readonly': !row.isEditing
          }"
          [disabled]="!row.isEditing"
          (click)="selectStar(row, i)"
          [attr.aria-hidden]="!row.isEditing ? 'true' : null"
          [attr.aria-pressed]="
            row.isEditing && i === getDisplayRating(row) - 1 ? 'true' : null
          "
        >
          <i
            class="fa-star lead"
            role="img"
            [ngClass]="{
              'far text-muted': i >= getDisplayRating(row),
              'fa text-warning': i < getDisplayRating(row)
            }"
            attr.aria-label="{{ i + 1 }} {{ 'wcag.ratingStars' | translate }}"
          ></i>
        </button>
      </div>
    </fieldset>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-white" (click)="close()">
    {{ 'general.cancel' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="isSaving || !hasChanges()"
    (click)="save()"
  >
    {{ 'general.save' | translate }}
  </button>
</div>
